/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const HappyIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path
				className='st0'
				d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.8 12.2 12.2 1.8 25 1.8c12.8 0 23.2 10.4 23.3 23.2 0 12.8-10.4 23.2-23.3 23.2z'
			/>
			<path
				className='st0'
				d='M17.7 20c.4.5.6 1.1.6 1.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-1-.3-1.9-1-2.7-1.2-1.1-3.1-1.1-4.4 0-.7.8-1 1.7-1 2.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.6.2-1.3.6-1.8.7-.5 1.7-.5 2.4.1zM31.3 19.1c-.7.8-1 1.7-1 2.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.6.2-1.3.6-1.8.7-.6 1.7-.6 2.5 0 .4.5.6 1.1.6 1.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-1-.3-1.9-1-2.7-1.3-1.1-3.3-1.1-4.5.1zM34.8 28.9h-.2l-19.1.1c-.3 0-.6.3-.6.6v.2c1.6 4.2 5.6 6.9 10 6.8 4.5 0 8.5-2.7 10.1-6.9.2-.4.1-.7-.2-.8z'
			/>
		</svg>
	)
}

export default HappyIcon
